import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import AccionMejora from "../CargaOm/AccionMejora";
import Cookies from "universal-cookie";

function ActualizaEstadoOmEvaluador(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [postEstado, setPostEstado] = useState("");
  const [postComentarios, setPostComentarios] = useState("");
  const [hasComentarios, setHasComentarios] = useState(false);

  const cookie = new Cookies();
  const tipoUsuario = cookie.get("tipo_Usuario"); // 👈 clave

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  // 🔍 Obtener datos actuales
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerGestionesPorIdOm/${props.idOm}`,
    })
      .then((response) => {
        setList(response.data);

        if (response.data.length > 0 && response.data[0].comentarios) {
          setPostComentarios(response.data[0].comentarios);
          setHasComentarios(true);
        } else {
          setPostComentarios("");
          setHasComentarios(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idOm]);

  // 🚀 POST
  const postData = (e) => {
    e.preventDefault();

    // 🔒 VALIDACIÓN DE PERMISO
    if (tipoUsuario !== 3 && tipoUsuario !== "3") {
      Swal.fire(
        "Acceso denegado",
        "No tienes permisos para actualizar",
        "error",
      );
      return;
    }

    if (!list || list.length === 0) {
      Swal.fire("Error", "No hay datos para actualizar", "error");
      return;
    }

    const actual = list[0];

    const dataCompleta = {
      ...actual,
      estado: postEstado || actual.estado,
      comentarios: postComentarios || actual.comentarios,
      accionMejora: actual.accionMejora,
      elementosVerificacion: actual.elementosVerificacion,
    };

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ActualizaGestionOm?IdPadre=${props.idOm}&IdOm=${props.idOm}`,
      data: dataCompleta,
    })
      .then((response) => {
        Swal.fire({
          title: response.data,
          text: "Actualizado correctamente",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "Verifique los campos", "error");
      });
  };

  return (
    <div className="test">
      <button
        className={`btn ${hasComentarios ? "btn-secondary" : "btn-primary"}`}
        onClick={handleOpenModalTest}
      >
        Gestion OM
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Actualizar Estado OM"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Hallazgos Om
                  </h6>
                </div>

                <div className="card-body">
                  <form className="user">
                    {/* ESTADO */}
                    <div className="form-group row">
                      <div className="col-sm-12">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          value={postEstado}
                          onChange={(e) => setPostEstado(e.target.value)}
                          disabled={tipoUsuario !== 3 && tipoUsuario !== "3"} // 🔒
                        >
                          <option value="">
                            Seleccione el estado de la Solicitud
                          </option>
                          <option value="Solucionada">Solucionada</option>
                          <option value="Parcial">Parcial</option>
                          <option value="Reiterada">Reiterada</option>
                          <option value="Devuelta">Devuelta</option>
                          <option value="En Gestión">En Gestión</option>
                        </select>
                      </div>
                    </div>

                    {/* COMENTARIOS */}
                    <div className="form-group row">
                      <div className="col-sm-12">
                        {tipoUsuario !== 3 && tipoUsuario !== "3" && (
                          <small className="text-muted">
                            Solo los evaluadores pueden editar este campo
                          </small>
                        )}

                        <textarea
                          className="form-control"
                          value={postComentarios}
                          onChange={(e) => setPostComentarios(e.target.value)}
                          readOnly={tipoUsuario !== 3 && tipoUsuario !== "3"} // 🔒
                        />
                      </div>
                    </div>

                    {/* BOTÓN */}
                    {tipoUsuario == 3 || tipoUsuario == "3" ? (
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    ) : (
                      <button
                        className="btn btn-secondary btn-user btn-block"
                        disabled
                      >
                        Guardar
                      </button>
                    )}
                  </form>
                </div>
              </div>

              {/* ACCION MEJORA */}
              <AccionMejora idOm={props.idOm} />
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default ActualizaEstadoOmEvaluador;
